import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no",
  "use": "icon-no-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-no\"><defs><style type=\"text/css\"></style></defs><path d=\"M1023 1022.9V158.2C1023 71.4 952.6 1 865.8 1H1.1L1023 1022.9z\" fill=\"#FF1E10\" opacity=\".8\" p-id=\"3075\" /><path d=\"M781.4 305.5L887.9 199c11.9-11.9 11.9-31.5 0-43.4l-5.5-5.5c-11.9-11.9-31.5-11.9-43.4 0L732.5 256.6 626.1 150.1c-11.9-11.9-31.5-11.9-43.4 0l-5.5 5.5c-11.9 11.9-11.9 31.5 0 43.4l106.5 106.5-106.6 106.4c-11.9 11.9-11.9 31.5 0 43.4l5.5 5.5c11.9 11.9 31.5 11.9 43.4 0l106.5-106.5L839 460.9c11.9 11.9 31.5 11.9 43.4 0l5.5-5.5c11.9-11.9 11.9-31.5 0-43.4L781.4 305.5z\" fill=\"#FFFFFF\" p-id=\"3076\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/no.svg
// module id = 3Wg0
// module chunks = 81